// Agenda time-overlap helpers for the Gathering wizard.
// Two events conflict when their [start, end) intervals intersect — touching
// endpoints (one ends exactly as the next begins) do NOT count. When an event
// has no explicit end time we assume a default duration for the check.

export const DEFAULT_DURATION_MS = 60 * 60 * 1000; // 1 hour

export function eventInterval(ev) {
  const start = new Date(ev.dateTime).getTime();
  const hasEnd = !!ev.endDateTime;
  const end = hasEnd ? new Date(ev.endDateTime).getTime() : start + DEFAULT_DURATION_MS;
  return { start, end, assumedEnd: !hasEnd };
}

export function overlaps(a, b) {
  const ia = eventInterval(a);
  const ib = eventInterval(b);
  return ia.start < ib.end && ib.start < ia.end;
}

/**
 * Given a list of agenda events (each with `id`, `dateTime`, optional
 * `endDateTime`), returns a map of eventId -> array of the events it conflicts
 * with. Empty entries are omitted.
 */
export function computeOverlaps(events) {
  const map = {};
  for (let i = 0; i < events.length; i += 1) {
    for (let j = i + 1; j < events.length; j += 1) {
      if (overlaps(events[i], events[j])) {
        (map[events[i].id] = map[events[i].id] || []).push(events[j]);
        (map[events[j].id] = map[events[j].id] || []).push(events[i]);
      }
    }
  }
  return map;
}
